/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type AirlineTicketTypes = typeof AirlineTicketTypes[keyof typeof AirlineTicketTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AirlineTicketTypes = {
  Individual: 'Individual',
  Group: 'Group',
  Both: 'Both',
} as const;
